import FastMarquee from "react-fast-marquee";
import { useReducedMotion } from "framer-motion";

const ITEMS = ["Est. 1907", "Broadstairs", "Artisan Gelato", "Seaside Magic", "Sundaes & Waffles", "Kent Coast", "Family Traditions"];

const Row = () => (
  <div className="flex items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-display italic text-2xl md:text-3xl text-teal px-6 whitespace-nowrap">{item}</span>
        <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" className="shrink-0">
          <rect x="3.5" y="3.5" width="7" height="7" transform="rotate(45 7 7)" fill="#C5A059" />
        </svg>
      </span>
    ))}
  </div>
);

const Marquee = () => {
  const reduce = useReducedMotion();
  return (
    <div data-testid="marquee-strip" className="bg-mint border-y border-gold/40 py-5 -rotate-1 scale-[1.02] my-4" aria-hidden="true">
      {reduce ? <div className="overflow-hidden"><Row /></div> : (
        <FastMarquee speed={28} gradient={false}>
          <Row />
        </FastMarquee>
      )}
    </div>
  );
};

export default Marquee;
